module.exports = __webpack_public_path__ + "static/media/14UNEP12.9aeef25b.jpg";